import SwatchListController from './swatch-list-controller'

export default SwatchListController
